import type { MailThread } from "../../../lib/mail";

/**
 * Who a reply to this thread goes to.
 *
 * The server works this out too, and will fall back to it when the request
 * carries no recipients. We compute it here anyway so the confirmation dialog
 * can NAME the recipient before the operator presses send: a dialog that shows
 * an empty To line while the server quietly picks one is not a confirmation of
 * anything. The caller then sends the same list explicitly, so what was shown
 * and what was addressed cannot drift apart.
 *
 * Same rule as the server (`replyAddresses` in the API's crm-email module):
 * reply to whoever last wrote in, and failing that to whoever the thread was
 * opened with. "Whoever wrote in" is the Reply-To the message named before it
 * is the sender. A form notice comes from Husly's no-reply address and names
 * the form filler as its Reply-To; answering the sender sent the reply to a
 * mailbox nobody reads.
 */
export function replyRecipients(thread: MailThread | null): string[] {
  const messages = thread?.messages ?? [];
  const lastInbound = [...messages].reverse().find((m) => m.direction === "inbound");
  if (lastInbound) {
    const named = (lastInbound.replyToAddresses ?? []).map((a) => a.trim()).filter(Boolean);
    return named.length ? named : [lastInbound.fromAddress];
  }
  return messages[0]?.toAddresses ?? [];
}
